export const adaptIssueTypesResponse = (response) => {
  return (
    response?.IssueTypes?.filter((each) => !each.subtask)?.map((each) => ({
      label: each.name,
      value: each.name,
      iconUrl: each.iconUrl,
    })) || []
  );
};
